import JMapCoord from "@/components/JComponents/JMap/components/JMapCoord.vue";
export default {
  components: { JMapCoord },
  data () {
    return {
      measureModules: [
        'esri/widgets/DistanceMeasurement2D',
        'esri/widgets/AreaMeasurement2D'
      ],
      // 工具测量相关变量
      currentMeasureType: '', // 当前测量工具['area', 'coordinate', 'distance']
      measureLayer: null, // 测量层
      showCoordinate: false,
      offsetHeight: 0,
      offsetWidth: 0,
      coordinateTarget: {} // 当前事件对象
    }
  },
  methods: {
    // 测量坐标
    measureCoordinate () {
      this.clearMapMeasure()
      this.initCoordinate()
      this.currentMeasureType = 'coordinate'
    },
    // 测量面积
    measureArea () {
      this.clearMapMeasure()
      this.currentMeasureType = 'area'
      this.measureLayer = new this.gisConstructor.AreaMeasurement2D({ view: this.view })
      this.measureLayer.viewModel.newMeasurement()
    },
    // 测量距离
    measureDistance () {
      this.clearMapMeasure()
      this.currentMeasureType = 'distance'
      this.measureLayer = new this.gisConstructor.DistanceMeasurement2D({ view: this.view })
      this.measureLayer.viewModel.newMeasurement()
    },
    // 计算坐标定位
    computeCoordinate (event) {
      let x = event.screenPoint.x
      let y = event.screenPoint.y
      let top = y
      let left = x
      // if (x < 10) left = x + 10
      if (x > (this.offsetWidth - 190)) left = x - 190
      if (y < (this.offsetHeight + 45)) top = y + 45
      // if (y > (this.offsetHeight - 65)) top = y - 25
      this.coordinateTarget = {
        latitude: event.mapPoint.latitude,
        longitude: event.mapPoint.longitude,
        left,
        // top
        top: top - 45
      }
      this.showCoordinate = true
    },
    // 初始化测量坐标
    initCoordinate () {
      const node = document.getElementById(this.mapRandomId)
      this.offsetHeight = node.offsetHeight
      this.offsetWidth = node.offsetWidth
    },
    // 清除测量结果
    clearMapMeasure () {
      this.currentMeasureType = ''
      this.showCoordinate = false
      if (!this.measureLayer) return
      this.measureLayer.destroy()
      this.measureLayer = null
    }
  }
}
